import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-problem',
  standalone: true,
  imports: [TranslateModule],
  template: `
    <section id="problem" class="py-20 md:py-28 bg-dark-100 relative overflow-hidden">
      <div class="max-w-7xl mx-auto px-5 md:px-10">
        
        <div class="max-w-xl mb-14" data-aos="fade-up">
          <p class="text-primary font-bold text-xs tracking-[0.2em] uppercase mb-3">{{ 'PROBLEM.LABEL' | translate }}</p>
          <h2 class="text-3xl md:text-[2.75rem] font-black mb-4 leading-[1.1]">
            {{ 'PROBLEM.TITLE' | translate }}
          </h2>
          <p class="text-base text-gray-450 leading-relaxed">
            {{ 'PROBLEM.DESC' | translate }}
          </p>
        </div>

        <div class="grid md:grid-cols-3 gap-4">
          <!-- Stat card -->
          <div class="bg-dark-300 rounded-2xl p-7 border border-white/[0.04]" data-aos="fade-up" data-aos-delay="100">
            <p class="text-5xl font-black text-accent-red mb-2">$0.003</p>
            <p class="text-sm text-gray-450 leading-relaxed">{{ 'PROBLEM.CARD_1_DESC' | translate }}</p>
          </div>

          <!-- What works -->
          <div class="bg-dark-300 rounded-2xl p-7 border border-white/[0.04]" data-aos="fade-up" data-aos-delay="200">
            <p class="text-xs font-bold text-accent-green tracking-[0.15em] uppercase mb-4">{{ 'PROBLEM.CARD_2_TITLE' | translate }}</p>
            <ul class="space-y-3 text-sm text-gray-350">
              <li class="flex items-start gap-2.5">
                <span class="w-1 h-1 rounded-full bg-accent-green mt-2 flex-shrink-0"></span>
                {{ 'PROBLEM.CARD_2_ITEM_1' | translate }}
              </li>
              <li class="flex items-start gap-2.5">
                <span class="w-1 h-1 rounded-full bg-accent-green mt-2 flex-shrink-0"></span>
                {{ 'PROBLEM.CARD_2_ITEM_2' | translate }}
              </li>
              <li class="flex items-start gap-2.5">
                <span class="w-1 h-1 rounded-full bg-accent-green mt-2 flex-shrink-0"></span>
                {{ 'PROBLEM.CARD_2_ITEM_3' | translate }}
              </li>
            </ul>
          </div>

          <!-- What doesn't -->
          <div class="bg-dark-300 rounded-2xl p-7 border border-white/[0.04]" data-aos="fade-up" data-aos-delay="300">
            <p class="text-xs font-bold text-accent-red tracking-[0.15em] uppercase mb-4">{{ 'PROBLEM.CARD_3_TITLE' | translate }}</p>
            <ul class="space-y-3 text-sm text-gray-350">
              <li class="flex items-start gap-2.5">
                <span class="w-1 h-1 rounded-full bg-accent-red mt-2 flex-shrink-0"></span>
                {{ 'PROBLEM.CARD_3_ITEM_1' | translate }}
              </li>
              <li class="flex items-start gap-2.5">
                <span class="w-1 h-1 rounded-full bg-accent-red mt-2 flex-shrink-0"></span>
                {{ 'PROBLEM.CARD_3_ITEM_2' | translate }}
              </li>
              <li class="flex items-start gap-2.5">
                <span class="w-1 h-1 rounded-full bg-accent-red mt-2 flex-shrink-0"></span>
                {{ 'PROBLEM.CARD_3_ITEM_3' | translate }}
              </li>
            </ul>
          </div>
        </div>

      </div>
    </section>
  `
})
export class ProblemComponent {}
